<template>
  <div
    class="tw-w-full tw-flex tw-gap-[40px] tw-flex-col tw-h-auto tw-p-[15px] tw-mt-[25px]"
  >
    <div class="tw-flex tw-flex-col tw-items-start tw-pr-[35px] tw-gap-[12px]">
      <div
        class="tw-text-[#211f58] tw-text-[18px] tw-font-medium tw-leading-[145%] title"
      >
        {{
          getComponentUiText(
            "app-assess-recommendations-action-table-label-tab-action-plan-1",
          )
        }}
      </div>
      <div
        class="tw-text-[#878787] tw-text-[14px] tw-font-normal tw-leading-[140%] sub-title"
      >
        {{
          getComponentUiText(
            "app-assess-recommendations-action-table-steps-solve-sub-title-1",
          )
        }}
      </div>
    </div>
    <div>
      <stepToSolve
        :check-list-group-id="data.item.checklistGroupId"
        :check-list-group-template-id="data.item.checklistGroupTemplateId"
        :disable="true"
        @is-check-list-step="isCheckListStep = $event"
      />
      <ButtonAddAnother
        v-if="!data.item.isSuggested"
        :style-button="'!tw-border-transparent !tw-shadow-none'"
        @click="addStep"
      >
        {{
          isCheckListStep
            ? getComponentUiText(
                "app-assess-recommendations-edit-action-modal-add-step-to-solve-1",
              )
            : getComponentUiText(
                "app-assess-recommendations-edit-action-modal-add-task-other-1",
              )
        }}</ButtonAddAnother
      >
    </div>
  </div>
</template>

<script lang="ts" setup>
import { ref } from "vue";
import { getComponentUiText } from "@/utils/utilities";
import stepToSolve from "@/components/recommend/editActionModalElement/stepToSolve.vue";
import ButtonAddAnother from "../wizard/buttonAddAnother.vue";
import { IModalMessage } from "@/interfaces/common/common";
import { MODAL_NAME } from "@/utils/constants";
import eventEmitter, { EmitterEvents } from "@/utils/eventEmitter";

const props = defineProps({
  data: {
    type: Object as () => any,
    required: false,
    default: null,
  },
});

const isCheckListStep = ref(false);

const addStep = () => {
  const emitData: IModalMessage = {
    component: MODAL_NAME.MODAL_RECOMMENDATION_EDIT_ACTIONS,
    properties: {
      action: props.data.item,
      isEditActionTable: true,
      shouldScrollToBottom: true,
    },
  };
  eventEmitter.emit(EmitterEvents.OPEN_MODAL, emitData);
};
</script>

<style lang="scss" scoped>
.title {
  font-family: Poppins;
}
.sub-title {
  font-family: Poppins;
}
.step {
  border: 1px solid var(--UI-rule, #eff0f1);
  box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.05);
}
.step-title {
  font-family: Poppins;
}
.arrow-up {
  transform: rotate(180deg);
}
.detail {
  border-top: 1px solid var(--UI-rule, #eff0f1);
  border-bottom-left-radius: 6px;
  border-bottom-right-radius: 6px;
}
.title-detail-step {
  font-family: Poppins;
}
.sub-title-detail-step {
  font-family: Poppins;
}
</style>
